import React, { useEffect, useMemo, useRef, useState } from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import AddIcon from "@mui/icons-material/Add";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import {
  AddTitleCardContainer,
  CardContainer,
  CardWrapper,
  Container,
  FooterButton,
  Header,
  Span,
  TitleInput,
  TitlePlaceholder,
  TitleNewCardInput,
} from "./styled";
import { ClickableIcon } from "../../CommonStyled";
import BottomButtonGroup from "../BottomButtonGroup/BottomButtonGroup";
import Card from "../Card/Card";
import { useDispatch } from "react-redux";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import DeleteIcon from "@mui/icons-material/DeleteForeverOutlined";
import {
  DeleteList,
  listTitleUpdate,
} from "../.././../../../../Services/boardService";
import { createCard } from "../../../../../../Services/listService";
import { Droppable, Draggable } from "react-beautiful-dnd";

const List = (props) => {
  const { cards } = props.info;
  const dispatch = useDispatch();

  const [clickTitle, setClickTitle] = useState(false);
  const [clickFooter, setClickFooter] = useState(false);
  const [collapsed, setCollapsed] = useState(false); // ⭐ NEW
  const [newCardTitle, setNewCardTitle] = useState("");
  const [currentListTitle, setCurrentListTitle] = useState(props.info.title);
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const ref = useRef();

  const countCards = useMemo(() => {
    if (!cards || cards.length <= 0) return null;
    return cards.length;
  }, [cards]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleFooterClick = async () => {
    setNewCardTitle("");
    await createCard(newCardTitle, props.info._id, props.info.owner, dispatch);
    ref && ref.current && ref.current.scrollIntoView({ behavior: "smooth" });
  };

  const handleFooterCloseClick = () => {
    setClickFooter(false);
    setNewCardTitle("");
  };

  const handleOnChangeTitle = (e) => {
    setCurrentListTitle(e.target.value);
  };

  const handleChangeTitle = async () => {
    if (props.info.title !== currentListTitle)
      await listTitleUpdate(
        props.info._id,
        props.info.owner,
        currentListTitle,
        dispatch
      );
  };

  const handleDeleteClick = () => {
    DeleteList(props.info._id, props.info.owner, dispatch);
    handleClose();
  };

  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setClickFooter(false);
      setNewCardTitle("");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (clickFooter) {
      ref.current.scrollIntoView();
    }
  }, [clickFooter]);

  return (
    <Draggable draggableId={props.info._id} index={props.index}>
      {(provided, snapshot) => (
        <Container
          {...provided.draggableProps}
          ref={provided.innerRef}
          isDragging={snapshot.isDragging}
        >
          <Header
            {...provided.dragHandleProps}
            isDragging={snapshot.isDragging}
          >
            <TitlePlaceholder
              show={clickTitle}
              onClick={() => setClickTitle(true)}
            >
              {currentListTitle}
              {countCards && <span>{` (${countCards})`}</span>}
            </TitlePlaceholder>

            <TitleInput
              onBlur={() => {
                setClickTitle(false);
                handleChangeTitle();
              }}
              ref={(input) => input && input.focus()}
              show={clickTitle}
              value={currentListTitle}
              onChange={handleOnChangeTitle}
            />

            <ClickableIcon
              color="#656565"
              aria-controls="basic-menu"
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              <MoreHorizIcon fontSize="small" />
            </ClickableIcon>

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
              {/* ⭐ NEW: Collapse / Expand */}
              <MenuItem
                onClick={() => {
                  setCollapsed((prev) => !prev);
                  handleClose();
                }}
              >
                <ListItemIcon>
                  {collapsed ? (
                    <UnfoldMoreIcon fontSize="small" />
                  ) : (
                    <UnfoldLessIcon fontSize="small" />
                  )}
                </ListItemIcon>
                <ListItemText>{collapsed ? "Mở rộng" : "Thu gọn"}</ListItemText>
              </MenuItem>

              {/* OLD */}
              <MenuItem onClick={handleDeleteClick}>
                <ListItemIcon>
                  <DeleteIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Xóa</ListItemText>
              </MenuItem>
            </Menu>
          </Header>

          {/* Cards */}
          {!collapsed && (
            <Droppable droppableId={props.info._id} direction="vertical">
              {(provided, snapshot) => (
                <CardContainer
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  isDraggingOver={snapshot.isDraggingOver}
                >
                  <CardWrapper dock={clickFooter}>
                    {props.info.cards
                      .filter((card) =>
                        props.searchString
                          ? card.title
                              .toLowerCase()
                              .includes(props.searchString.toLowerCase())
                          : true
                      )
                      .map((card, index) => (
                        <Card
                          boardId={props.boardId}
                          boardTitle={props.boardTitle}
                          listId={props.info._id}
                          key={card._id}
                          index={index}
                          info={card}
                        />
                      ))}

                    {provided.placeholder}

                    {clickFooter && (
                      <AddTitleCardContainer ref={ref}>
                        <TitleNewCardInput
                          value={newCardTitle}
                          autoFocus
                          placeholder="Nhập tiêu đề của thẻ..."
                          height={Math.floor(newCardTitle.length / 16) + "rem"}
                          onChange={(e) => setNewCardTitle(e.target.value)}
                        />
                        <BottomButtonGroup
                          title="Thêm"
                          clickCallback={handleFooterClick}
                          closeCallback={handleFooterCloseClick}
                        />
                      </AddTitleCardContainer>
                    )}
                  </CardWrapper>
                </CardContainer>
              )}
            </Droppable>
          )}

          {!collapsed && !clickFooter && (
            <FooterButton onClick={() => setClickFooter(true)}>
              <AddIcon fontSize="small" />
              <Span>Thêm 1 thẻ</Span>
            </FooterButton>
          )}
        </Container>
      )}
    </Draggable>
  );
};

export default List;
